import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';
import logo from './logo.svg';
import video from './tmp.mp4';
import './App.css';

const Home = () => (
  <div>
    <h2>Home</h2>
    <p>
      This is the homepage.
    </p>
  </div>
)

const About = () => (
  <div>
    <h2>About</h2>
    <p>
      About us goes here.
    </p>
    <p>
      <video autoPlay loop muted>
        <source src={video} type="video/mp4" />
      </video>
    </p>
  </div>
)

class App extends Component {
  render() {
    return (
			<Router>
				<div className="App">
					<header className="App-header">
						<img src={logo} className="App-logo" alt="logo" />
						<h1 className="App-title">Welcome to Propcards?</h1>
					</header>
					<p className="App-intro">
						<ul>
							<li><Link to="/">Home</Link></li>
							<li><Link to="/about">About</Link></li>
						</ul>
						<hr />
						<Route exact path="/" component={Home}/>
						<Route path="/about" component={About}/>
					</p>
				</div>
			</Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js